<template>
  <main class="app-main">
    <div class="app-content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">تعديل نشرة عقارية</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/latestNews">النشرات العقارية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">تعديل</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="app-content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <mainLoader v-if="mainLoading" />
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
            <LatestNewsForm
              v-if="!mainLoading && dataRow"
              card-title="تعديل النشرة"
              :dataRow="dataRow"
            />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import LatestNewsForm from './form.vue';

export default {
  name: 'LatestNewsUpdate',
  components: { LatestNewsForm },
  data() {
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      dataRow: null,
    };
  },
  methods: {
    getRow() {
      this.mainLoading = true;
      this.hasError    = false;
      this.$http.get(`/api/admin/latestNews/retrieve/${this.$route.params.id}`).then(({ data }) => {
        this.dataRow  = data.row;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.mainLoading = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
  },
  created() {
    this.getRow();
  },
};
</script>